import React, { useState, useEffect } from "react";
import ConfirmAlertEmailBig from "./ConfirmAlertEmailBig";
import ConfirmAlertEmailSmall from "./ConfirmAlertEmailSmall";

// Custom hook to detect device type
function useDevice() {
	const [device, setDevice] = useState(getDeviceType());

	function getDeviceType() {
		const width = window.innerWidth;
		if (width < 768) return "mobile";
		if (width < 1024) return "tablet";
		return "desktop";
	}

	useEffect(() => {
		function handleResize() {
			setDevice(getDeviceType());
		}

		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	return device;
}

// Main component
export default function ConfirmAlertEmail(props) {
	const device = useDevice();

	return (
		<div>
			{device === "mobile" && <ConfirmAlertEmailSmall match={props.match} history={props.history} />}
			{device === "tablet" && <ConfirmAlertEmailBig match={props.match} history={props.history} />}
			{device === "desktop" && <ConfirmAlertEmailBig match={props.match} history={props.history} />}
		</div>
	);
}
